import { FC } from 'react';
import { Divider } from '@optimus-web/core';
import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { DateTimeUtils, lt, useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { FormMetaSection } from '@mews-commander/ui';

interface CreatedAndUpdatedFieldsProps {
    promotedService: PromotedServiceAssignment;
}

export const CreatedAndUpdatedFields: FC<CreatedAndUpdatedFieldsProps> = ({ promotedService }) => {
    const timezone = useTimezone();
    const localizationInfo = useDateTimeLocalizationInfo();
    const { createdUtc, updatedUtc, creatorProfileName, updaterProfileName } = promotedService;

    const createdDateTme = DateTimeUtils.dateTimeUtcStringToDateTimeString(createdUtc, localizationInfo, timezone);
    const updatedDateTme = DateTimeUtils.dateTimeUtcStringToDateTimeString(updatedUtc, localizationInfo, timezone);

    return (
        <>
            <Divider>{lt(TextKey.History)}</Divider>
            <FormMetaSection
                meta={{
                    createdDateTime: createdDateTme,
                    creatorName: creatorProfileName,
                    updatedDateTime: updatedDateTme,
                    updaterName: updaterProfileName,
                }}
            />
        </>
    );
};
